export default __webpack_public_path__ + "static/media/group-people-green.ae5d3bfb.svg";